import { useMemo } from 'react';
import { useApi } from '@/api/useApi';
import { useQueryProvider } from './use-query-provider';
import { QUERY_KEYS } from '@/constants/QueryKeys';
import { EXPERT_ATTRIBUTE_EXTERNAL_CODES } from '@/constants';
import { useAuthStore } from '@/zustand/auth/store';
import { parseJwt } from '@/utility';

export interface BoutiqueMenuSubItem {
	name: string;
	description: string;
}

export interface BoutiqueMenuGroup {
	liveServiceGroupName: string;
	subMenuItems: BoutiqueMenuSubItem[];
}

export const BOUTIQUE_GROUP_NAME = 'BOUTIQUE';
export const BOUTIQUE_GROUP_TITLE = 'Butik Sınıf';

export const BoutiqueMenuItem = {
	CALENDAR: 'BOUTIQUE_CALENDAR',
	MY_STUDENTS: 'BOUTIQUE_MY_STUDENTS'
} as const;

export const BOUTIQUE_MENU_GROUP: BoutiqueMenuGroup = {
	liveServiceGroupName: BOUTIQUE_GROUP_NAME,
	subMenuItems: [
		{ name: BoutiqueMenuItem.CALENDAR, description: 'Takvim' },
		{ name: BoutiqueMenuItem.MY_STUDENTS, description: 'Öğrencilerim' }
	]
};

export function useBoutiqueMenu(options: { enabled?: boolean } = {}) {
	const { enabled = true } = options;
	const { ExpertControllerApi } = useApi();
	const { data: authData } = useAuthStore();
	const userId = useMemo(() => (authData?.access_token ? parseJwt(authData?.access_token)?.sub : ''), [authData?.access_token]);

	const { data: expertDetailInfo } = useQueryProvider(
		[QUERY_KEYS.getLoggedInExpertDetailInfo, userId],
		() => ExpertControllerApi.getLoggedInExpertDetailInfo(),
		{
			select: ({ data }) => data?.data,
			refetchOnWindowFocus: false,
			enabled: enabled && !!userId
		}
	);

	const hasBoutiqueAccess = useMemo(
		() => !!expertDetailInfo?.attributeList?.some(attribute => attribute?.attributeExternalCode === EXPERT_ATTRIBUTE_EXTERNAL_CODES.BUTIK),
		[expertDetailInfo]
	);

	return { hasBoutiqueAccess, boutiqueMenuGroup: BOUTIQUE_MENU_GROUP };
}
